'use strict';

var $ = require('jquery');
var basePage = require('../pages/base-page.js');
var layout = require('../ui/layout.js');
var slider = require('../components/slider.js');
var motorwayWidget = require('../components/motorway-widget.js');

var classNames = {
	valuationDetailsPage: 'valuation-details-page'
};

var $mileageSlider = null;

function initVanSliders() {
	$mileageSlider = $.findByBem(classNames.valuationDetailsPage + '__adjustments__mileage-slider');
	var $mileageInput = $.findByBem(classNames.valuationDetailsPage, 'adjustments__mileage-container__input-container__input');
	var maxSliderValue = Number($('#maxSliderValue').val());

	if ($mileageSlider.length > 0 && $mileageInput.length > 0) {
		var mileageSliderOptions = {
			range: {
				'min': 1,
				'max': maxSliderValue
			},
			start: $mileageInput.val(),
			step: 1,
			tooltips: false,
			isVanValuation: true
		};

		$mileageSlider = slider.initMilesSlider($mileageSlider, mileageSliderOptions, $mileageInput);
	}
}

function scrollToVanAdjustments() {
	var $adjustments = $.findByBem(classNames.valuationDetailsPage, 'adjustments');

	if ($adjustments.length > 0) {
		$('html, body').animate({
			scrollTop: $adjustments.offset().top - layout.getContentOffset(true)
		}, 'slow');
	}
}

function initShowVanAdjustments() {
	$.findByBem(classNames.valuationDetailsPage, 'valuation-variation__button').on('click', scrollToVanAdjustments);
	$.findByBem(classNames.valuationDetailsPage, 'button').on('click', scrollToVanAdjustments);
}

basePage.init = function() {
	basePage.initBasePage();
	initVanSliders();
	initShowVanAdjustments();
	motorwayWidget.init();	
};

module.exports = basePage;